import template from './sw-theme-manager-detail.html.twig';

const { Component } = Shopware;

Component.override('sw-theme-manager-detail', {
    template,

    inject: ['systemConfigApiService'],

    data() {
        return {
            configTheme: {},
            isLoading: false
        };
    },

    computed: {
        isRhwebTheme() {
            return this.theme?.technicalName?.toLowerCase().includes('rhweb') || false;
        },

        showConfigBoxes() {
            return this.configTheme?.[`${this.theme.technicalName}.config.rhwebActivateThemeConfigHints`];
        },

        getThemeName() {
            return this.theme?.technicalName?.toLowerCase().replace('rhweb', '') || '';
        },

        getThemeNameUpper() {
            return this.theme?.technicalName
                ?.replace('RHWeb', '')
                .replace('Theme', '')
                .replace('Pro', ' Pro')
                .replace('Cleue', 'Caprice')
                .replace('one', ' One') || '';
        }
    },

    watch: {
        isRhwebTheme: {
            handler(val) {
                if (val) {
                    this.addThemeClass();
                    this.fetchThemeConfig(this.theme.technicalName);
                }
            },
            immediate: true
        }
    },

    methods: {
        fetchThemeConfig(name) {
            this.isLoading = true;
            return this.systemConfigApiService
                .getValues(`${name}.config`, null)
                .then(values => this.configTheme = values)
                .finally(() => this.isLoading = false);
        },

        addThemeClass() {
            this.$el?.classList?.add(`rhwebthememanager-${this.theme.technicalName.toLowerCase()}`);
        },

        getIcon(icon) {
            return `/bundles/${this.theme?.technicalName?.toLowerCase()}/administration/static/img/rhweb-icon-${icon}.png`;
        },

        isExtensionActive(name) {
            return Shopware.Store.get('shopwareExtensions')?.myExtensions?.data?.some(
                ext => ext.name === name && ext.active
            ) || false;
        }
    }
});
